import Config from '@/config/bl-config.js'
import Vue from 'vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'

Vue.use(VueReCaptcha, { siteKey: Config.recaptchaSiteKey })
